module.exports = __webpack_public_path__ + "img/1481789740.7ab511b9.jpg";